import Spacer from "@src/components/ui/Spacer";
import AutoLayout from "@src/deprecatedDesignSystem/components/AutoLayout";
import { FC } from "react";
import { StepHeader } from "./StepHeader";
import HrisEmployeeListContainer from "../HrisEmployeeListContainer";

type Props = {
  inHrisCsvSetup?: boolean;
};

export const VerifyStep: FC<Props> = ({ inHrisCsvSetup = false }) => {
  return (
    <AutoLayout direction="vertical" flex={1}>
      <StepHeader step="verify" />
      <Spacer size={20} />
      <HrisEmployeeListContainer
        inHrisCsvSetup={inHrisCsvSetup}
        excludeColumns={["syncedAt", "status"]}
        showOverflowMenu={false}
        showInviteFilter={false}
      />
    </AutoLayout>
  );
};
